// @ts-nocheck
import BookingAssistanceLink from "../../pages/booking-assistance/BookingAssistanceLink";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { Box } from "@mui/system";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// import {  } from '../../store/';
import LogoutIcon from "../../assets/images/logout.svg";
import {
  alertDialogAciton,
  freelanceEcLogoutAction,
  logoutAction,
} from "../../store/actions/auth";
import "./sidebar.css";

import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { FRONTEND_CONFIG } from "../../utils/constants/configs";

const SidebarFreelanceEc = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const auth = useSelector((store) => store.auth);
  const groupMessaging = useSelector((store) => store.groupMessaging);
  const oneOnOneMessaging = useSelector((store) => store.oneOnOneMessaging);

  // useEffect start...
  // React.useEffect(() => {
  //   if (!auth?.userToken) {
  //     navigate("/");
  //   }
  // }, [auth]);
  // useEffect end...

  return (
    <>
      {/* <Box sx={{width: '100px', minWidth: '100px'}}></Box> */}
      <Box className="sidebar-container">
        <Box className="top-routes">
          <BookingAssistanceLink />
          <Box
            sx={{
              "& a": {
                background: "transparent",
                minHeight: "auto !important",
                padding: "16px 20px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                "&.active": {
                  border: "1px solid #D175B6",
                  color: "#D175B6",
                },
              },
            }}
          >
            <Link
              to="/event/all-events"
              className={
                location.pathname === "/event/all-events" ||
                location.pathname.includes("/event/details") ||
                location.pathname.includes("/dashboard/details")
                  ? "active"
                  : ""
              }
            >
              Approved Events
            </Link>
          </Box>

          {/* <Accordion className="accordion"> */}
          {/*   <AccordionSummary */}
          {/*     expandIcon={<KeyboardArrowDownIcon sx={{ color: "#ffffff" }} />} */}
          {/*     aria-controls="panel1-content" */}
          {/*     id="panel1-header" */}
          {/*     className="accordion-summary" */}
          {/*     sx={{ */}
          {/*       "&.Mui-expanded": { */}
          {/*         border: "1px solid #D175B6", */}
          {/*         "& p": { */}
          {/*           color: "#D175B6", */}
          {/*         }, */}
          {/*         "& svg": { */}
          {/*           color: "#D175B6", */}
          {/*         }, */}
          {/*       }, */}
          {/*     }} */}
          {/*   > */}
          {/*     <Typography>Events</Typography> */}
          {/*   </AccordionSummary> */}
          {/*   <AccordionDetails */}
          {/*     sx={{ overflow: "hidden" }} */}
          {/*     className="accordion-details" */}
          {/*   > */}
          {/*     <Box */}
          {/*       sx={{ */}
          {/*         "& a": { */}
          {/*           margin: "4px 0", */}
          {/*           width: "100%", */}
          {/*           color: "#ffffff", */}
          {/*           padding: "8px 14px", */}
          {/*           borderRadius: "4px", */}
          {/*           border: "1px solid transparent", */}
          {/*           position: "relative", */}
          {/*           "&:before": { */}
          {/*             content: '""', */}
          {/*             position: "absolute", */}
          {/*             width: "12px", */}
          {/*             height: "81px", */}
          {/*             borderRadius: "0 0 0 10px", */}
          {/*             borderBottom: "1px solid #ffffff", */}
          {/*             borderLeft: "1px solid #ffffff", */}
          {/*             left: "-13px", */}
          {/*             bottom: "13px", */}
          {/*           }, */}
          {/*           "& span": { */}
          {/*             height: "24px", */}
          {/*             width: "24px", */}
          {/*             background: "#FFF", */}
          {/*             color: "#D175B6", */}
          {/*             borderRadius: "100%", */}
          {/*             marginLeft: "5px", */}
          {/*             lineHeight: "24px", */}
          {/*             textAlign: "center", */}
          {/*             display: "inline-block", */}
          {/*             position: "absolute", */}
          {/*             right: "9px", */}
          {/*             top: "5px", */}
          {/*           }, */}
          {/*           "&.active": { */}
          {/*             color: "#D175B6", */}
          {/*             borderColor: "#D175B6", */}
          {/*             "&:before": { */}
          {/*               borderBottom: "1px solid #D175B6", */}
          {/*               borderLeft: "1px solid #D175B6", */}
          {/*               zIndex: "1", */}
          {/*             }, */}
          {/*             "& span": { */}
          {/*               background: "#D175B6", */}
          {/*               color: "#fff", */}
          {/*             }, */}
          {/*           }, */}
          {/*         }, */}
          {/*         "& a + a:before": { */}
          {/*           height: "954px", */}
          {/*         }, */}
          {/*       }} */}
          {/*     > */}
          {/*       <Link */}
          {/*         to="/event/all-events" */}
          {/*         className={ */}
          {/*           location.pathname === "/event/all-events" || */}
          {/*           location.pathname.includes("/event/details") || */}
          {/*           location.pathname.includes("/dashboard/details") */}
          {/*             ? "active" */}
          {/*             : "" */}
          {/*         } */}
          {/*       > */}
          {/*         Approved Events */}
          {/*       </Link> */}
          {/*     </Box> */}
          {/*   </AccordionDetails> */}
          {/* </Accordion> */}

          {/* NOTE: contract routes */}
          {/* {FRONTEND_CONFIG.contracts && ( */}
          {/*   <Box */}
          {/*     sx={{ */}
          {/*       "& a": { */}
          {/*         background: "transparent", */}
          {/*         minHeight: "auto !important", */}
          {/*         padding: "16px 20px", */}
          {/*         color: "#ffffff", */}
          {/*         fontSize: "20px", */}
          {/*         border: "1px solid transparent", */}
          {/*         borderRadius: "8px", */}
          {/*         width: "100%", */}
          {/*         "&.active": { */}
          {/*           border: "1px solid #D175B6", */}
          {/*           color: "#D175B6", */}
          {/*         }, */}
          {/*       }, */}
          {/*     }} */}
          {/*   > */}
          {/*     <Link */}
          {/*       to="/contracts" */}
          {/*       className={ */}
          {/*         location.pathname == "/contracts" || */}
          {/*         location.pathname == "/contract-details" */}
          {/*           ? "active" */}
          {/*           : "" */}
          {/*       } */}
          {/*     > */}
          {/*       Contracts */}
          {/*     </Link> */}
          {/*   </Box> */}
          {/* )} */}

          {/* <Box */}
          {/*   sx={{ */}
          {/*     "& a": { */}
          {/*       background: "transparent", */}
          {/*       minHeight: "auto !important", */}
          {/*       padding: "16px 20px", */}
          {/*       color: "#ffffff", */}
          {/*       fontSize: "20px", */}
          {/*       border: "1px solid transparent", */}
          {/*       borderRadius: "8px", */}
          {/*       width: "100%", */}
          {/*       "&.active": { */}
          {/*         border: "1px solid #D175B6", */}
          {/*         color: "#D175B6", */}
          {/*       }, */}
          {/*     }, */}
          {/*   }} */}
          {/* > */}
          {/*   <Link */}
          {/*     to="/positions" */}
          {/*     className={location.pathname == "/positions" ? "active" : ""} */}
          {/*   > */}
          {/*     Positions */}
          {/*   </Link> */}
          {/* </Box> */}

          {/* <Box */}
          {/*   sx={{ */}
          {/*     "& a": { */}
          {/*       background: "transparent", */}
          {/*       minHeight: "auto !important", */}
          {/*       padding: "16px 20px", */}
          {/*       color: "#ffffff", */}
          {/*       fontSize: "20px", */}
          {/*       border: "1px solid transparent", */}
          {/*       borderRadius: "8px", */}
          {/*       width: "100%", */}
          {/*       "&.active": { */}
          {/*         border: "1px solid #D175B6", */}
          {/*         color: "#D175B6", */}
          {/*       }, */}
          {/*     }, */}
          {/*   }} */}
          {/* > */}
          {/*   <Link */}
          {/*     to="/contractors" */}
          {/*     className={location.pathname == "/contractors" ? "active" : ""} */}
          {/*   > */}
          {/*     Contractors */}
          {/*   </Link> */}
          {/* </Box> */}

          {/* <Box */}
          {/*   sx={{ */}
          {/*     "& a": { */}
          {/*       background: "transparent", */}
          {/*       minHeight: "auto !important", */}
          {/*       padding: "16px 20px", */}
          {/*       color: "#ffffff", */}
          {/*       fontSize: "20px", */}
          {/*       border: "1px solid transparent", */}
          {/*       borderRadius: "8px", */}
          {/*       width: "100%", */}
          {/*       "&.active": { */}
          {/*         border: "1px solid #D175B6", */}
          {/*         color: "#D175B6", */}
          {/*       }, */}
          {/*     }, */}
          {/*   }} */}
          {/* > */}
          {/*   <Link */}
          {/*     to="/find-sow" */}
          {/*     className={location.pathname == "/find-sow" ? "active" : ""} */}
          {/*   > */}
          {/*     SOW / (PO/TimeSheet) */}
          {/*   </Link> */}
          {/* </Box> */}
          {/* <Accordion */}
          {/*   sx={{ */}
          {/*     background: "transparent", */}
          {/*     boxShadow: "none", */}
          {/*   }} */}
          {/* > */}
          {/*   <AccordionSummary */}
          {/*     expandIcon={<KeyboardArrowDownIcon sx={{ color: "#ffffff" }} />} */}
          {/*     aria-controls="panel2-content" */}
          {/*     id="panel2-header" */}
          {/*     sx={{ */}
          {/*       background: "transparent", */}
          {/*       color: "primary", */}
          {/*       minHeight: "auto !important", */}
          {/*       padding: "16px 20px", */}
          {/*       border: "1px solid transparent", */}
          {/*       borderRadius: "8px", */}
          {/*       "&.Mui-expanded": { */}
          {/*         border: "1px solid #D175B6", */}
          {/*         "& p": { */}
          {/*           color: "#D175B6", */}
          {/*         }, */}
          {/*         "& svg": { */}
          {/*           color: "#D175B6", */}
          {/*         }, */}
          {/*       }, */}
          {/*       "& .MuiAccordionSummary-content": { */}
          {/*         margin: "0 !important", */}
          {/*         fontSize: "20px", */}
          {/*         "& p": { */}
          {/*           fontSize: "20px", */}
          {/*         }, */}
          {/*       }, */}
          {/*     }} */}
          {/*   > */}
          {/*     <Typography>Users</Typography> */}
          {/*   </AccordionSummary> */}
          {/*   <AccordionDetails */}
          {/*     sx={{ */}
          {/*       padding: "0 0 0 46px", */}
          {/*       overflow: "hidden", */}
          {/*     }} */}
          {/*   > */}
          {/*     <Box */}
          {/*       sx={{ */}
          {/*         "& a": { */}
          {/*           margin: "4px 0", */}
          {/*           width: "100%", */}
          {/*           color: "#ffffff", */}
          {/*           padding: "8px 14px", */}
          {/*           borderRadius: "4px", */}
          {/*           border: "1px solid transparent", */}
          {/*           position: "relative", */}
          {/*           "&:before": { */}
          {/*             content: '""', */}
          {/*             position: "absolute", */}
          {/*             width: "12px", */}
          {/*             height: "81px", */}
          {/*             borderRadius: "0 0 0 10px", */}
          {/*             borderBottom: "1px solid #ffffff", */}
          {/*             borderLeft: "1px solid #ffffff", */}
          {/*             left: "-13px", */}
          {/*             bottom: "13px", */}
          {/*           }, */}
          {/*           "& span": { */}
          {/*             height: "24px", */}
          {/*             width: "24px", */}
          {/*             background: "#FFF", */}
          {/*             color: "#D175B6", */}
          {/*             borderRadius: "100%", */}
          {/*             marginLeft: "5px", */}
          {/*             lineHeight: "24px", */}
          {/*             textAlign: "center", */}
          {/*             display: "inline-block", */}
          {/*             position: "absolute", */}
          {/*             right: "9px", */}
          {/*             top: "5px", */}
          {/*           }, */}
          {/*           "&.active": { */}
          {/*             color: "#D175B6", */}
          {/*             borderColor: "#D175B6", */}
          {/*             "&:before": { */}
          {/*               borderBottom: "1px solid #D175B6", */}
          {/*               borderLeft: "1px solid #D175B6", */}
          {/*               zIndex: "1", */}
          {/*             }, */}
          {/*             "& span": { */}
          {/*               background: "#D175B6", */}
          {/*               color: "#fff", */}
          {/*             }, */}
          {/*           }, */}
          {/*         }, */}
          {/*         "& a + a:before": { */}
          {/*           height: "954px", */}
          {/*         }, */}
          {/*       }} */}
          {/*     > */}
          {/*       <Link */}
          {/*         to="/users/coordinators" */}
          {/*         className={ */}
          {/*           location.pathname == "/users/coordinators" ? "active" : "" */}
          {/*         } */}
          {/*       > */}
          {/*         Coordinators */}
          {/*       </Link> */}
          {/*     </Box> */}
          {/*   </AccordionDetails> */}
          {/* </Accordion> */}
          {/* <Box
                sx={{
                "& a": {
                    background: "transparent",
                    minHeight: "auto !important",
                    padding: "16px 20px",
                    color: "#ffffff",
                    fontSize: "20px",
                    border: "1px solid transparent",
                    borderRadius: "8px",
                    width: "100%",
                    "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                    },
                },
                }}
            >
                <Link
                    to="/logs-of-event"
                    className={location.pathname == "/logs-of-event" ? "active" : ""}
                >
                    Logs Of Request
                </Link>
            </Box> */}

          {/* <Accordion */}
          {/*   sx={{ */}
          {/*     background: "transparent", */}
          {/*     boxShadow: "none", */}
          {/*   }} */}
          {/* > */}
          {/*   <AccordionSummary */}
          {/*     expandIcon={<KeyboardArrowDownIcon sx={{ color: "#ffffff" }} />} */}
          {/*     aria-controls="panel2-content" */}
          {/*     id="panel2-header" */}
          {/*     sx={{ */}
          {/*       background: "transparent", */}
          {/*       color: "primary", */}
          {/*       minHeight: "auto !important", */}
          {/*       padding: "16px 20px", */}
          {/*       border: "1px solid transparent", */}
          {/*       borderRadius: "8px", */}
          {/*       "&.Mui-expanded": { */}
          {/*         border: "1px solid #D175B6", */}
          {/*         "& p": { */}
          {/*           color: "#D175B6", */}
          {/*         }, */}
          {/*         "& svg": { */}
          {/*           color: "#D175B6", */}
          {/*         }, */}
          {/*       }, */}
          {/*       "& .MuiAccordionSummary-content": { */}
          {/*         margin: "0 !important", */}
          {/*         fontSize: "20px", */}
          {/*         "& p": { */}
          {/*           fontSize: "20px", */}
          {/*         }, */}
          {/*       }, */}
          {/*     }} */}
          {/*   > */}
          {/*     <Typography>Configuration</Typography> */}
          {/*   </AccordionSummary> */}
          {/*   <AccordionDetails */}
          {/*     sx={{ */}
          {/*       padding: "0 0 0 46px", */}
          {/*       overflow: "hidden", */}
          {/*     }} */}
          {/*   > */}
          {/*     <Box */}
          {/*       sx={{ */}
          {/*         "& a": { */}
          {/*           margin: "4px 0", */}
          {/*           width: "100%", */}
          {/*           color: "#ffffff", */}
          {/*           padding: "8px 14px", */}
          {/*           borderRadius: "4px", */}
          {/*           border: "1px solid transparent", */}
          {/*           position: "relative", */}
          {/*           "&:before": { */}
          {/*             content: '""', */}
          {/*             position: "absolute", */}
          {/*             width: "12px", */}
          {/*             height: "91px", */}
          {/*             borderRadius: "0 0 0 10px", */}
          {/*             borderBottom: "1px solid #ffffff", */}
          {/*             borderLeft: "1px solid #ffffff", */}
          {/*             left: "-13px", */}
          {/*             bottom: "13px", */}
          {/*           }, */}
          {/*           "& span": { */}
          {/*             height: "24px", */}
          {/*             width: "24px", */}
          {/*             background: "#FFF", */}
          {/*             color: "#D175B6", */}
          {/*             borderRadius: "100%", */}
          {/*             marginLeft: "5px", */}
          {/*             lineHeight: "24px", */}
          {/*             textAlign: "center", */}
          {/*             display: "inline-block", */}
          {/*             position: "absolute", */}
          {/*             right: "9px", */}
          {/*             top: "5px", */}
          {/*           }, */}
          {/*           "&.active": { */}
          {/*             color: "#D175B6", */}
          {/*             borderColor: "#D175B6", */}
          {/*             "&:before": { */}
          {/*               borderBottom: "1px solid #D175B6", */}
          {/*               borderLeft: "1px solid #D175B6", */}
          {/*               zIndex: "1", */}
          {/*             }, */}
          {/*             "& span": { */}
          {/*               background: "#D175B6", */}
          {/*               color: "#fff", */}
          {/*             }, */}
          {/*           }, */}
          {/*         }, */}
          {/*         "& a + a:before": { */}
          {/*           height: "954px", */}
          {/*         }, */}
          {/*       }} */}
          {/*     > */}
          {/*       <Link */}
          {/*         to="/configuration/text-templates" */}
          {/*         className={ */}
          {/*           location.pathname == "/configuration/text-templates" */}
          {/*             ? "active" */}
          {/*             : "" */}
          {/*         } */}
          {/*       > */}
          {/*         Text Templates */}
          {/*       </Link> */}
          {/*       <Link */}
          {/*         to="/configuration/tutorial-video" */}
          {/*         className={ */}
          {/*           location.pathname == "/configuration/tutorial-video" */}
          {/*             ? "active" */}
          {/*             : "" */}
          {/*         } */}
          {/*       > */}
          {/*         Tutorial Video */}
          {/*       </Link> */}
          {/*     </Box> */}
          {/*   </AccordionDetails> */}
          {/* </Accordion> */}

          <Box
            sx={{
              "& a": {
                background: "transparent",
                minHeight: "auto !important",
                padding: "16px 20px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                "&.active": {
                  border: "1px solid #D175B6",
                  color: "#D175B6",
                },
              },
            }}
          >
            <Link
              to="/profile"
              className={location.pathname == "/profile" ? "active" : ""}
            >
              Profile
            </Link>
          </Box>

          {/* <Box */}
          {/*   sx={{ */}
          {/*     "& a": { */}
          {/*       background: "transparent", */}
          {/*       minHeight: "auto !important", */}
          {/*       padding: "16px 20px", */}
          {/*       color: "#ffffff", */}
          {/*       fontSize: "20px", */}
          {/*       border: "1px solid transparent", */}
          {/*       borderRadius: "8px", */}
          {/*       width: "100%", */}
          {/*       "&.active": { */}
          {/*         border: "1px solid #D175B6", */}
          {/*         color: "#D175B6", */}
          {/*       }, */}
          {/*     }, */}
          {/*   }} */}
          {/* > */}
          {/*   <Link */}
          {/*     to="/generate-qr" */}
          {/*     className={location.pathname == "/generate-qr" ? "active" : ""} */}
          {/*   > */}
          {/*     Generate QR Code */}
          {/*   </Link> */}
          {/* </Box> */}

          <Box>
            <Accordion className="accordion">
              <AccordionSummary
                expandIcon={<KeyboardArrowDownIcon sx={{ color: "#ffffff" }} />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="accordion-summary"
                sx={{
                  "&.Mui-expanded": {
                    border: "1px solid #D175B6",
                    "& p": {
                      color: "#D175B6",
                    },
                    "& svg": {
                      color: "#D175B6",
                    },
                  },
                }}
              >
                <Typography>Messages</Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{ overflow: "hidden" }}
                className="accordion-details"
              >
                <Box
                  sx={{
                    "& a": {
                      margin: "4px 0",
                      width: "100%",
                      color: "#ffffff",
                      padding: "8px 14px",
                      borderRadius: "4px",
                      border: "1px solid transparent",
                      position: "relative",
                      "&:before": {
                        content: '""',
                        position: "absolute",
                        width: "12px",
                        height: "91px",
                        borderRadius: "0 0 0 10px",
                        borderBottom: "1px solid #ffffff",
                        borderLeft: "1px solid #ffffff",
                        left: "-13px",
                        bottom: "13px",
                      },
                      "& span": {
                        height: "24px",
                        width: "24px",
                        background: "#FFF",
                        color: "#D175B6",
                        borderRadius: "100%",
                        marginLeft: "5px",
                        lineHeight: "24px",
                        textAlign: "center",
                        display: "inline-block",
                        position: "absolute",
                        right: "9px",
                        top: "5px",
                      },
                      "&.active": {
                        color: "#D175B6",
                        borderColor: "#D175B6",
                        "&:before": {
                          borderBottom: "1px solid #D175B6",
                          borderLeft: "1px solid #D175B6",
                          zIndex: "1",
                        },
                        "& span": {
                          background: "#D175B6",
                          color: "#fff",
                        },
                      },
                    },
                    "& a + a:before": {
                      height: "954px",
                    },
                  }}
                >
                  <Link
                    to="/event/chat"
                    className={
                      location.pathname === "/event/chat" ? "active" : ""
                    }
                  >
                    Event Chat
                    {groupMessaging?.unreadChatRoomsCount?.data?.groupCount >
                    0 ? (
                      <Typography
                        variant="span"
                        sx={{
                          background: `${getCssVariableHandler({
                            variableName: "--primary-pink-rgb",
                          })} !important`,
                          color: `${getCssVariableHandler({
                            variableName: "--font-rgb",
                          })} !important`,
                        }}
                      >
                        {groupMessaging?.unreadChatRoomsCount?.data?.groupCount}
                      </Typography>
                    ) : null}
                  </Link>
                  <Link
                    to="/event/chat/admin"
                    className={
                      location.pathname === "/event/chat/admin" ? "active" : ""
                    }
                  >
                    Admins
                    {oneOnOneMessaging?.unreadChatRoomsCount?.data
                      ?.oneOnOneCount > 0 ? (
                      <Typography
                        variant="span"
                        sx={{
                          background: `${getCssVariableHandler({
                            variableName: "--primary-pink-rgb",
                          })} !important`,
                          color: `${getCssVariableHandler({
                            variableName: "--font-rgb",
                          })} !important`,
                        }}
                      >
                        {
                          oneOnOneMessaging?.unreadChatRoomsCount?.data
                            ?.oneOnOneCount
                        }
                      </Typography>
                    ) : null}
                  </Link>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Box>
        </Box>
        <Box>
          <Button
            sx={{
              background: "#000000",
              minHeight: "auto !important",
              padding: "16px 20px",
              color: "#ffffff",
              fontSize: "16px",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              boxShadow: "0px 0px 30px 0px rgba(209, 117, 182, 0.20)",
              justifyContent: "center",
              cursor: "pointer",
              width: "100%",
              "& img": {
                marginRight: "15px",
              },
              "&:hover": {
                background: "#000000",
                minHeight: "auto !important",
                padding: "16px 20px",
                color: "#ffffff",
                fontSize: "16px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                boxShadow: "0px 0px 30px 0px rgba(209, 117, 182, 0.20)",
                justifyContent: "center",
                cursor: "pointer",
                width: "100%",
                "& img": {
                  marginRight: "15px",
                },
              },
              // "& p": {
              //   background: "#000000",
              //   minHeight: "auto !important",
              //   padding: "16px 20px",
              //   color: "#ffffff",
              //   fontSize: "16px",
              //   borderRadius: "8px",
              //   display: "flex",
              //   alignItems: "center",
              //   boxShadow: "0px 0px 30px 0px rgba(209, 117, 182, 0.20)",
              //   justifyContent: "center",
              //   cursor: "pointer",
              //   width: "100%",
              //   "& img": {
              //     marginRight: "15px",
              //   },
              // },
            }}
            onClick={(e) => {
              dispatch(
                alertDialogAciton({
                  open: true,
                  title: "Confirm Logout",
                  message: "Are you sure, you want to logout?",
                  onOk: () => {
                    dispatch(freelanceEcLogoutAction({}));
                    navigate("/login");
                  },
                  okLabel: "Logout",
                  closeLabel: "Stay Logged In",
                }),
              );
            }}
          >
            <img src={LogoutIcon} />
            Logout
            {/* <p
              onClick={(e) => {
                dispatch(logoutAction({}));
              }}
            >
              <img src={LogoutIcon} />
              Logout
            </p> */}
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default SidebarFreelanceEc;